import { uniq } from 'lodash';
import { isEmail } from 'helper';
import { DefectAct } from './interfaces';

// Из 1С в contragent_rs.emails может прийти лишний текст (должность, ФИО): режем по ; , и пробелам, берём только email
export function parseContragentEmails(emailsStr?: string | null): string[] {
  return uniq(
    (emailsStr ?? '')
      .split(/[;,\s]+/)
      .map((part) => part.trim())
      .filter(isEmail),
  );
}

// Бэк фактически шлёт перевёрнутую нумерацию относительно изначальной доки:
// 23 = создано, 24 = отправлено
export enum EPreNotificationStatuses {
  'Pre-уведомление создано' = 23,
  'Предварительное уведомление отправлено' = 24,
}

export enum EDefectActStatuses {
  'Создан дефектный акт' = 1,
  'Создано уведомление' = 2,
  'Уведомление отправлено' = 3,
  'Требует калькуляции' = 5,
  'На калькуляции' = 6,
  'Посчитан ПТО' = 7,
  'Отправлен в 1с' = 8,
  'Закрыт без ресурсов' = 9,
  'Отправлено в ПТО' = 10,
  'Утверждено' = 11,
  'Отклонено' = 12,
  'Дополнен' = 13,
  'На подписании' = 14,
  'Подписан получателем' = 15,
  'Подписан отправителем' = 16,
  'Подписан обоюдно' = 17,
  'Заблокирован' = 18,
  'Разблокирован' = 19,
  'Устраняется подрядчиком' = 20,
  'Дефектный акт распечатан' = 21,
  'Дефектный акт дополнен и распечатан' = 22,
  'Уведомление обновлено' = 100,
}

export function hasStatuses(statuses: (keyof typeof EDefectActStatuses)[], defectAct?: DefectAct.IDefectAct) {
  return statuses.map((status) => EDefectActStatuses[status]).includes(defectAct?.defectActStatusId!);
}

export function startFromStatus(status: keyof typeof EDefectActStatuses, defectAct?: DefectAct.IDefectAct) {
  return defectAct?.defectActStatusId! >= EDefectActStatuses[status] || false;
}
